$(() => {
  const annual_labor_expense = () => {
    const net_pt_revenue = parseFloat($('#net-pt-revenue').val().replaceAll(',', ''));

    return 0.5 * net_pt_revenue;
  };

  const run = () => {
    if ($('#annual-labor-expense-overridden').val() === '0') {
      $('#annual-labor-expense').val(accounting.formatMoney(annual_labor_expense(), '', 0));
    }
  };

  run();

  $('#net-pt-revenue').blur(() => {
    run();
  });

  $('#annual-labor-expense').blur(() => {
    $('#annual-labor-expense-overridden').val('1');
  });
});
